import { authenticated, api } from './index';

export const saveBulkResourceAssigner = (_: unknown, payload: unknown) =>
  authenticated(api).post(`v1.1/resource_assign/bulk_import/`, payload);

export const saveResourceAssigner = (
  params: { templateId: string },
  payload: unknown,
) =>
  authenticated(api).post(
    `v1.1/resource_assign/${params.templateId}/bulk_import_single_project/`,
    payload,
  );

export const getSampleResourceAssigner = (params: { templateId: string }) =>
  authenticated(api).get(
    `/resource_code_list/${params.templateId}/sample_template_url/`,
  );
